import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const caseRpjLocationValidationSchema = Yup.object({
  community: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
});
